import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable, forkJoin, throwError, Subscription, interval, takeWhile, EMPTY, lastValueFrom, take } from "rxjs";
import * as _ from 'lodash';
import { map, mergeMap, catchError, switchMap, startWith, skipWhile } from "rxjs/operators";
import { FileService, User, CacheService, ToastrService } from 'mapfre-auditlib';
import { TranslateService } from '@ngx-translate/core';
import * as FileSaver from 'file-saver';
import { truncate } from "fs";

@Injectable({
   providedIn: "root"
})
export class RecommendationService {

   className = 'RecommendationService';

   constructor(private http: HttpClient, private fileService: FileService, private cacheService: CacheService,
      private toastService: ToastrService, private translateService: TranslateService) { }

   //!NO se usa
   getRecommendationByFactObserverId(factObserverId, jobId): Observable<any[]> {
      return this.http.get<any[]>(environment.base_URL + "/recommendation", { params: { factObserverId: factObserverId, jobId } });
   }

   getRecommendationById(id): Observable<any[]> {
      return this.http.get<any[]>(environment.base_URL_GAIA + `/recommendation/${id}`);
   }

   getImpactTypesRecommendation(cache = true, cacheKey = "recImpactTypes"): Observable<any[]> | any {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         let observable = this.http.get<any[]>(environment.base_URL + '/recommendation/impact-types').pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

   getProbabilityTypesRecommendation(cache = true, cacheKey = "recProbabilityTypes"): Observable<any[]> | any {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         let observable = this.http.get<any[]>(environment.base_URL + '/recommendation/probability-types').pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

   exportRecommendation(key, params) {

      const user_locale = window.navigator.language;
      _.set(params, "locale", user_locale);

      _.set(params, "key", key + '/data.json');

      this.toastService.add({ severity: "info", summary: this.translateService.instant("TOAST.GENERAL.INFO_LOADING_TITLE"), detail: this.translateService.instant("TOAST.GENERAL.INFO_EXPORT"), life: 240000 });

      // Call aws gateway to generate pre signed url
      return this.http.get<any[]>(environment.base_URL + "/exported-url", { params })
         .pipe(mergeMap((res: any) => {

            // Remove key paramenter and add url parameter
            _.unset(params, "key")
            _.set(params, "url", res)

            // Call Mapgre Gateway to generate excel with exoprted jobs
            return this.http.get<any[]>(environment.base_URL + "/exported-recommendations", { params })
               .pipe(mergeMap((res: any) => {

                  // Remove url paramenter and add key parameter
                  let paramsExcel = {}
                  _.set(paramsExcel, "keydata", key + '/data.json');
                  _.set(paramsExcel, "keyexcel", key + '/export.xlsx');

                  return this.http.get<any[]>(environment.base_URL + "/create-excel", { params: paramsExcel })
                     .pipe(mergeMap((res3: any) => {

                        // Remove url paramenter and add key parameter
                        let paramsDownload = {}
                        _.set(paramsDownload, "onlyDownload", true)

                        let body = {
                              key: key + '/export.xlsx'
                            }

                        // Download excel
                        return this.http.post(environment.base_URL + `/download`, body, { params: paramsDownload })
                           .pipe(mergeMap((res: any) => {

                              // Download file
                              let options = {
                                 responseType: "blob" as 'json'
                              }

                              // Download file form S3
                              return this.http.get(res, options);

                           }), map(res => {

                              //Clear toast notification
                              this.toastService.clear()
                              //Download generated Excel
                              FileSaver.saveAs(res, `export.xlsx`);

                              // Delete file when downloaded
                              this.delete(key).subscribe(() => { });
                              return res;

                           }), catchError(err => {
                              this.toastService.add({
                                 severity: "error",
                                 summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
                                 detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
                              });
                              return throwError(err);
                           }))
                     }))
               }))

         }), map(res => {
            return res;
         }), catchError<Observable<any>, any>((err) => {

            if(err.status != 500){ 

               let target = {};
               _.set(target, "keyFile", key + '/data.json');

               let ob: Observable<any>;
               let cont = 0;

               //Condiciones de timeout y repetición de request a check-files
               function checkConditions(response){
                  if(cont <18 && response.statusCode === 404){
                     cont++;
                     return true;
                  }else{
                     cont++;
                     return false
                  }
               }

               //Multiple request to lambda chech-files. Stops when file has been found or timeout
               ob = interval(5000)
               .pipe(
               startWith(0),
               switchMap(() => this.http.get<any>(environment.base_URL + "/check-files", { params: target })),
               takeWhile(response => checkConditions(response), true)
               )

               forkJoin([ob]).subscribe(([check]) => {

                  if(check.statusCode === 200){

                     let paramsExcel = {}
                     _.set(paramsExcel, "keydata", key + '/data.json');
                     _.set(paramsExcel, "keyexcel", key + '/export.xlsx');

                     let result = forkJoin( [this.http.get<any[]>(environment.base_URL + "/create-excel", { params: paramsExcel })])

                     return forkJoin([result]).subscribe(([resul1]) => {

                        // Remove url paramenter and add key parameter
                        let paramsDownload = {}
                        _.set(paramsDownload, "onlyDownload", true)

                        let body = {
                           key: key + '/export.xlsx'
                        }

                        // Download excel
                        let result2 = this.http.post(environment.base_URL + `/download`, body, { params: paramsDownload })
                           .pipe(mergeMap((res: any) => {
                              // Download file
                              let options = {
                                 responseType: "blob" as 'json'
                              }

                              //Clear toast notification
                              this.toastService.clear()

                              // Download file form S3
                              return this.http.get(res, options);

                           }), map(res => {

                              // Delete file when downloaded
                              this.delete(key).subscribe(() => { });
                              return res;

                           }), catchError(err => {
                              this.toastService.add({
                                 severity: "error",
                                 summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
                                 detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
                              });
                              return throwError(err);
                           }))

                           return forkJoin([result2]).subscribe(([resul2]) => {
                              //Download generated Excel
                              FileSaver.saveAs(resul2, `export.xlsx`);
                              return resul2;
                           });
                     });
                  }else{
                     //Clear toast info notification
                     this.toastService.clear()

                     this.toastService.add({
                        severity: "error",
                        summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
                        detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TIMEOUT"), life: 5000
                     });
                  }
            });
            }else{
               //Clear toast info notification
               setTimeout(() => {
                  this.toastService.clear()
               },4000)
            }

         return EMPTY;
         }))
   }

   delete(key): any {
      let params = {
         key
      }
      return this.http.post(environment.base_URL + "/delete", { params }).pipe(catchError(err => {
         this.toastService.add({
            severity: "error",
            summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
            detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
         });
         return throwError(err);
      }));
   }

   comment(comment) {
      return this.http.post(environment.base_URL_GAIA + `/recommendation/comment`, comment);
   }

   getCommentsRecommendaionById(id) {
      let params = {
         recommendationIds: id.join(',')
      };
      return this.http.get(environment.base_URL_GAIA + `/recommendations/comments`, { params });
   }

   getAllRecommendations(select: any = false, cache=true, cacheKey = "allRecommendations"): Observable<any[]> | any {
      if (this.cacheService.canUseCache(cacheKey, [select ? 'lite' : 'full']) && cache) {
         return this.cacheService.getCacheData(cacheKey, [select ? 'lite' : 'full']);
      } else {
         let observable = this.http.get<any[]>(environment.base_URL + "/recommendation", { params: { select: select } }).pipe(map((res) => {
            if (cache) {
               this.cacheService.updateCacheData(res, cacheKey, [select ? 'lite' : 'full'])
            }
            return res;
         }))
         if (cache) {
            this.cacheService.updateCacheReq(cacheKey, [select ? 'lite' : 'full']);
         }
         return observable;
      }
   }

   removeRecommendationByProgramJobId(programJobId, code): Observable<any[]> {
      return this.http.delete<any[]>(environment.base_URL + "/recommendation/" + programJobId + "/code/" + code);
   }

   createRecommendation(recommendation): Observable<any[]> {
      return this.http.post<any[]>(environment.base_URL + "/recommendation", recommendation);
   }

   updateRecommendation(recommendation): Observable<any[]> {
      return this.http.put<any[]>(environment.base_URL_GAIA + "/recommendation", recommendation);
   }

   getTypeCritiqueRecommendation(cache = true, cacheKey = 'typeCritique'): Observable<any[]> | any {

      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
      } else {
         let observable = this.http.get<any[]>(environment.base_URL + "/types-critique-recommendation").pipe(map((res) => {
            this.cacheService.updateCacheData(res, cacheKey)
            return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
      }

   }

   getTypeStatusRecommendation(cache = true, cacheKey = "typeStatus"): Observable<any[]> | any {

      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
      } else {
         let observable = this.http.get<any[]>(environment.base_URL + "/types-status-recommendation").pipe(map((res) => {
            this.cacheService.updateCacheData(res, cacheKey)
            return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
      }
   }

   getTypeStatusActionPlan(cache = true, cacheKey = "typeStatusActionPlan"): Observable<any[]> | any {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
      } else {
         let observable = this.http.get<any[]>(environment.base_URL + "/types-status-action-plan").pipe(map((res) => {
            this.cacheService.updateCacheData(res, cacheKey)
            return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
      }
   }

   getTypeRiskRecommendation(cache = true, cacheKey = "typeRisk"): Observable<any[]> | any {

      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
      } else {
         let observable = this.http.get<any[]>(environment.base_URL + "/types-risk").pipe(map((res) => {
            this.cacheService.updateCacheData(res, cacheKey)
            return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
      }

   }

   deleteRecommendation(recommendationId, recommendationCode): Observable<any[]> {
      return this.http.delete<any[]>(environment.base_URL + "/recommendation/" + recommendationId + "/code/" + recommendationCode);
   }

   getAllByJobId(jobId, cache?, cacheKey = "allByJobId"): Observable<any[]> | any {

      if (this.cacheService.canUseCache(cacheKey, [jobId]) && cache) {
         return this.cacheService.getCacheData(cacheKey, [jobId]);
      } else {
         let observable = this.http.get<any[]>(environment.base_URL + "/recommendation", { params: { jobId: jobId } }).pipe(map((res) => {
            if (cache) {
               this.cacheService.updateCacheData(res, cacheKey, [jobId])
            }
            _.forEach(res, (r) => {
               if (_.get(r, 'actionPlan.userResponsible.idUserPk')) {
                  r.actionPlan.userResponsible = new User(r.actionPlan.userResponsible);
               }
            })
            return res;
         }))
         if (cache) {
            this.cacheService.updateCacheReq(cacheKey, [jobId]);
         }
         return observable;
      }


   }

   updateActionPlan(actionPlan): Observable<any[]> {
      return this.http.put<any[]>(environment.base_URL + "/recommendation/action-plan", actionPlan);
      //return of([1989,1999,2009]);
   }

   createActionPlan(actionPlan): Observable<any[]> {
      return this.http.post<any[]>(environment.base_URL + "/recommendation/action-plan", actionPlan);
      //return of([1948]);
   }

   /***
    *  Recomendation Status
    */

   newTypeStatusRecommendation(status) {
      return this.http.post(environment.base_URL + "/types-status-recommendation", status)
   }

   updateTypeStatusRecommendation(status, id) {
      return this.http.put(environment.base_URL + `/types-status-recommendation/${id}`, status)
   }

   /***
    *  Recomendations Critique
    */


   newTypeCritiqueRecommendation(critique) {
      return this.http.post(environment.base_URL + "/types-critique-recommendation", critique)
   }

   updateTypeCritiqueRecommendation(critique, id) {
      return this.http.put(environment.base_URL + `/types-critique-recommendation/${id}`, critique)
   }

   export(recommendation, jobId): Observable<any[]> {
      let params = {
         jobId
      }
      let options = {
         params,
         responseType: "blob" as 'json'
      }
      return this.http.post<any[]>(environment.base_URL_GAIA + "/recommendation/" + recommendation.idtSqn + "/export", recommendation, options);
   }

   createRecommendationWithFiles(recommendation): Observable<any> {
      // PRE FILES INI
      let filesToUpload = _.remove(_.get(recommendation, '[0].files'), (f) => f instanceof File);
      // PRE FILES END
      //CHECK IF THERE ARE NEW FILES
      if (!_.isEmpty(filesToUpload)) {
         return this.createRecommendation(recommendation).pipe(mergeMap((res: any) => {
            let observables = _.map(filesToUpload, (f) => this.fileService.upload(f, 'recommendation', _.get(res, '[0]'), 'auditor/private'));
            return forkJoin(observables).pipe(map(resultFiles => {
               return res;
            }));
         }))
      }
      else {
         return this.createRecommendation(recommendation);
      }
   }

   updateRecommendationWithFiles(recommendation): Observable<any> {
      // PRE FILES INI
      console.log(recommendation)
      const files: any[] = recommendation?.[0]?.files ?? [];
      const filesToUpload = files.filter((f) => f instanceof File);
      recommendation[0].files = files.filter((f) => !(f instanceof File));
      console.log(filesToUpload)
      // PRE FILES END
      //CHECK IF THERE ARE NEW FILES
      if (filesToUpload.length > 0) {
         return this.updateRecommendation(recommendation).pipe(mergeMap((res: any) => {
            const observables = filesToUpload.map((f) => this.fileService.upload(f, 'recommendation', recommendation?.[0]?.idtSqn, 'auditor/private'));
            return forkJoin(observables).pipe(map(resultFiles => {
               return res;
            }));
         }))
      }
      else {
         return this.updateRecommendation(recommendation);
      }
   }

   getFilteredRecommendations(params, apply = false): Observable<any[]> {
      let observable = this.http.get<any[]>(environment.base_URL_GAIA + "/filtered_recommendations", { params }).pipe(map((res) => {
 
         if(params.page === 0 && apply === true){
            this.cacheService.updateCacheData(res, "rdnSearchCached")
            this.cacheService.updateCacheData(params, "filtersRdnCache")
         }
         return res;
      }));
      return observable;
   }

   /**
    * Delete Cache
    */

   deleteCache() {

      let memoryCache = ["typeCritique", "typeRisk", "allByJobId", "typeStatus", "allRecommendations", "typeStatusActionPlan"];

      _.forEach(memoryCache, item => {
         this.cacheService.deleteCache(item);
      })

   }


}
